export enum NominationsState {
    preNomination = 'preNomination',
    duringNomination = 'duringNomination',
    postNomination = 'postNomination',
}
